export const MATERIAL_LIST_EXPORT_ID = 'material-list';

export const MATERIAL_LIST_TITLE = 'Lista de Materiales';

export const LOCALIZED_PROPERTIES = {
  code: 'Codigo',
  name: 'Nombre',
  statusId: 'Estado',

};
